import { __awaiter, __generator } from "tslib";
import React, { useContext, useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { FilterContext } from "@contexts/FilterContext";
import { ContactAPIContext } from "@shared/contexts/api";
import { ContactExtractors } from "@shared/models/contact";
import { CollapsibleInlineFilter } from "./CollapsibleInlineFilter";
export var ContactFilter = React.memo(function (props) {
    var filterKey = props.filterKey, isCollapsed = props.isCollapsed, onToggle = props.onToggle;
    var intl = useIntl();
    var contactAPI = useContext(ContactAPIContext);
    var _a = useContext(FilterContext), appliedFilters = _a.appliedFilters, setAppliedFilter = _a.setAppliedFilter;
    var fetchOptions = useCallback(function (page, perPage, options) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, contactAPI.listContacts({
                    page: page,
                    perPage: perPage,
                    search: options.search,
                })];
        });
    }); }, [contactAPI]);
    var onSelect = useCallback(function (items) {
        setAppliedFilter({ contacts: items });
    }, [setAppliedFilter]);
    var title = useMemo(function () {
        return intl.formatMessage({ id: "common.tags.contact" });
    }, [intl]);
    var searchPlaceholder = useMemo(function () {
        return intl.formatMessage({ id: "common.search" });
    }, [intl]);
    var onToggleFilter = useCallback(function () {
        onToggle(filterKey);
    }, [filterKey, onToggle]);
    return (React.createElement(CollapsibleInlineFilter, { isCollapsed: isCollapsed, onToggle: onToggleFilter, selected: appliedFilters.contacts, onSelect: onSelect, getOptions: fetchOptions, title: title, searchPlaceholder: searchPlaceholder, labelExtractor: ContactExtractors.name, descriptionExtractor: ContactExtractors.emails, keyExtractor: ContactExtractors.id }));
});
